module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('f7-statusbar', {
    attrs: {
      "theme": _vm.statusColor
    }
  }), _vm._v(" "), _c('div', {
    class: {
      hiddenBlock: !_vm.isConnected
    },
    attrs: {
      "id": "panel"
    }
  }, [_c('left-panel')], 1), _vm._v(" "), _c('f7-views', [_c('f7-view', {
    attrs: {
      "domCache": false,
      "uniqueHistory": false,
      "id": "main-view",
      "navbar-through": "",
      "dynamic-navbar": true,
      "main": "",
      "url": "/login/"
    }
  }, [_c('f7-navbar', {
    style: (_vm.titleNavBar),
    attrs: {
      "fill": ""
    }
  }, [_c('f7-nav-center', {
    attrs: {
      "sliding": ""
    }
  })], 1), _vm._v(" "), _c('f7-pages'), _vm._v(" "), _c('bottom-toolbar')], 1)], 1), _vm._v(" "), _c('cm-popups'), _vm._v(" "), _c('user-guide')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-101ea5ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-101ea5ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1623
// module chunks = 2